import { render, staticRenderFns } from "./global-forms-list.vue?vue&type=template&id=7016d71a&"
import script from "./global-forms-list.vue?vue&type=script&lang=js&"
export * from "./global-forms-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports